import { Flex, Heading } from "@sidelinesports/fan-design-system";
import { PowerupFillIcon } from "@sidelinesports/icons";
import type { ApiPlayerDetails } from "../../../api";
import { PlayerAvatar } from "./PlayerAvatar";
import styles from "./PlayerInputRow.module.css";
import { SliderInput } from "./SliderInput";

export type PlayerInputRowProps = {
  player: ApiPlayerDetails;
  tokens: number;
  maxTokens: number;
  maxOverallTokens: number;
  onChange: (tokens: number) => void;
  isDisabled?: boolean;
};

export const PlayerInputRow = ({
  player,
  tokens,
  maxTokens,
  maxOverallTokens,
  onChange,
  isDisabled = false,
}: PlayerInputRowProps) => {
  return (
    <Flex gap={16} align="center" style={{ overflow: "hidden" }}>
      <PlayerAvatar player={player} />
      <Flex
        direction="column"
        w="100%"
        justify="between"
        style={{ overflow: "hidden" }}
      >
        <Flex
          direction="row"
          justify="between"
          align="center"
          style={{ overflow: "hidden" }}
        >
          <Flex direction="column" w="100%" style={{ overflow: "hidden" }}>
            <Heading
              as="div"
              level={6}
              className={styles["player-first-name"]}
              color="readable-on-dark"
            >
              {player.firstName}
            </Heading>
            <Heading as="div" level={2} className={styles["player-last-name"]}>
              {player.lastName}
            </Heading>
          </Flex>
          <Flex direction="row" align="center" gap={4}>
            <PowerupFillIcon
              fontSize="1.5rem"
              style={{
                color: "var(color-brand-secondary-surface-default)",
              }}
            />
            <Heading as="div" level={2}>
              {tokens}
            </Heading>
          </Flex>
        </Flex>
        <SliderInput
          value={tokens}
          min={0}
          absoluteMax={maxOverallTokens}
          constrainedMax={maxTokens}
          step={1}
          onChange={(e) => onChange(Number(e.target.value))}
          label="Power-up Tokens"
          hideLabel
          description={`Max: ${maxTokens}`}
          disabled={isDisabled}
        />
      </Flex>
    </Flex>
  );
};
